<template>
  <div>
    <div v-if="infoVisible" class="form-label">신용카드(월 구독)이란?</div>
    <ul v-if="infoVisible">
      <li>사용 시작일로부터 종료일까지 한 달 단위 무이자 납부 방식입니다.</li>
      <li>카드 등록 후 정해진 결제일에 자동 결제됩니다.</li>
      <li>해지 시 해당월 요금에 대해 환불금이 책정됩니다.</li>
    </ul>
    <div class="form-label mt-2">월 구독 시 월납액(VAT 10% 포함함)</div>
    <v-container fluid>
      <v-sheet class="overflow-x-auto">
        <DxScrollView width="100%" height="100%" direction="horizontal" show-scrollbar="always" :scroll-by-content="true">
          <v-simple-table class="custom-table" style="min-width: 80px">
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="tableTitle" v-for="(col, index) in columns" :key="`col_${index}`">
                    {{ col.dueDt }}
                  </th>
                </tr>
                <tr>
                  <td v-for="(row, index) in columns" :key="`row_${index}`">
                    <span class="d-flex align-center justify-center">
                      {{ `${formatToKoreanWon(row.paymentAmount)}원` }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </DxScrollView>
      </v-sheet>
    </v-container>
    <ul>
      <li>첫 결제에는 컨설팅 요금이 포함됩니다.</li>
      <li>첫 결제 이후 매월 월 단위 요금은 사용 시작일로부터 계산합니다.</li>
      <li>매월 요금제 월 단위 요금 + 부가세가 결제됩니다.</li>
      <li>일할계산이 될 경우 일할요금(1자리 올림) + 부가세가 결제됩니다.</li>
    </ul>
  </div>
</template>
<script>
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { getPreMonth, getDateFormat, getDateDiff } from '@/utils/common.js'
import dayjs from 'dayjs'
import { getCurrentDate } from '../../utils/common'

import { DxScrollView } from 'devextreme-vue/scroll-view'
export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: { DxScrollView },
  props: {
    paymentInfo: {
      type: Object,
      default: () => {},
    },
    infoVisible: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      gridData: [],
      columns: [],
    }
  },
  watch: {
    'paymentInfo.extraAmount': {
      deep: true,
      handler() {
        this.columns[0].paymentAmount =
          this.paymentInfo.amountPerMonth + this.paymentInfo.extraAmount + (this.paymentInfo.amountPerMonth + this.paymentInfo.extraAmount) / 10
      },
    },
  },
  created() {},
  activated() {},
  beforeMount() {},
  mounted() {
    this.setGridData()
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      if (date.indexOf('-') == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}.${month}.${day}`
      } else if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    formatToKoreanWon(value) {
      // 문자열을 숫자로 파싱하여 한국 원 단위로 포맷팅
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      }
      return 0
    },
    // 테이블 데이터 세팅
    setGridData() {
      const result = []
      console.log('# this.paymentInfo', this.paymentInfo)
      let firstPayment = this.paymentInfo.amountPerMonth + this.paymentInfo.extraAmount // 첫 결제 요금
      let firstVat = firstPayment / 10 // 첫 결제 수수료

      let startDt = dayjs(this.paymentInfo.constructDtS) // 결제 시작일
      if (this.paymentInfo.paymentStatus === 'S') {
        // 공사 중지 상태일 때, 미리 결제하는날은 결제 시작되는 일부터 할당
        startDt = dayjs(this.paymentInfo.paymentDt)
      }
      let endDt = dayjs(this.paymentInfo.constructDtE) // 결제 종료일
      result.push({
        dueDt: startDt.format('YYYY.MM.DD'),
        paymentAmount: firstPayment + firstVat,
      })
      let first = true
      let startDateIsFirstDay = false
      // console.log('## s', startDt.format('YYYY.MM.DD'))
      // console.log('## e', endDt.format('YYYY.MM.DD'))
      // console.log('## data', this.paymentInfo.amountPerMonth, this.paymentInfo.amountPerMonth / 10)
      if (startDt.date() === 1) {
        startDateIsFirstDay = true
      }
      while (startDt < endDt) {
        // 마지막 결제일까지 반복
        result.push({
          dueDt: startDt.add(1, 'month').format('YYYY.MM.DD'),
          paymentAmount: this.paymentInfo.amountPerMonth + this.paymentInfo.amountPerMonth / 10,
        })
        if (first && this.paymentInfo.paymentStatus === 'S') {
          result[0].dueDt = getCurrentDate().replaceAll('-', '.')
        }
        // 해당 월의 마지막 날짜가 아니면 -1일
        startDt = dayjs(startDt.add(1, 'month').format('YYYYMMDD'))
        if (first) {
          // startDt = startDt.subtract(1, 'day')
          result[result.length - 1].dueDt = startDt.format('YYYY.MM.DD')
        }
        if (startDateIsFirstDay) {
          // 시작일이 1일일 경우 결제일은 다음달 마지막 날을 기준으로 함
          startDt = startDt.set('date', startDt.endOf('month').date())
          result[result.length - 1].dueDt = startDt.format('YYYY.MM.DD')
        }
        first = false
      }
      const dateDiff = getDateDiff(result[result.length - 1].dueDt, endDt.format('YYYY.MM.DD'))
      if (dateDiff.month == 0 && dateDiff.date == -1) {
        // result[result.length - 1].paymentAmount = this.paymentInfo.amountPerMonth + this.paymentInfo.amountPerMonth / 10
        result.splice(result.length - 1, 1)
      } else if (result[result.length - 1].dueDt > endDt.format('YYYY.MM.DD')) {
        //   // 마지막 값을 제거하고 마지막 달에 일할요금 부여
        //   // let remainDate = getDateDiff(result[result.length - 2].dueDt.replaceAll('.', ''), endDt.format('YYYYMMDD'))
        let remainDate = getDateDiff(result[result.length - 2].dueDt, this.paymentInfo.constructDtE)
        let amountPerDay = Math.ceil((remainDate.date * this.paymentInfo.amountPerDay) / 10) * 10
        result[result.length - 2].paymentAmount = amountPerDay + amountPerDay / 10
        result.splice(result.length - 1)
      } else if (result[result.length - 1].dueDt == endDt.format('YYYY.MM.DD')) {
        // 마지막 결제일과 공사 종료일이 같을 때 금액 0원처리

        result[result.length - 1].paymentAmount = this.paymentInfo.amountPerDay
      }

      if (this.paymentInfo.constructDtS > getCurrentDate().replaceAll('-', '')) {
        // 미리 결제하는 경우
        result[0].dueDt = getCurrentDate().replaceAll('-', '.')
      }
      this.columns = result
    },
  },
}
</script>

<style scoped>
.right-input >>> input {
  text-align: right;
}
.overflow-x-auto {
  overflow-x: auto;
  white-space: nowrap;
}

.custom-table {
  min-width: 200px;
}
</style>
